<button type="button" [class.isLoading]="isLoading" [class.disabled]="disabled" [class.hasPrefix]="!!prefixTemplate" [ngClass]="variant">
  <ng-container *ngTemplateOutlet="prefixTemplate"></ng-container>

  <span class="content">
    <ng-content></ng-content>
  </span>

  <vc-spinner *ngIf="isLoading"></vc-spinner>
</button>
